import Api from './/api'
import { useEffect, useState } from 'react';
import { trackLinkClick } from '@snowplow/browser-plugin-link-click-tracking';
import {getCookie} from './utils';
const {EXCLUDED_PM_ENTITYID_FOR_CHATBOT,KEY_CHAIN} = require('../constants.js');

export default function ChatBot(props) {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get("accessToken");
    let userPMEntityId = props?.userDetails?.pmEntityID;
  const getBrowserType = () => {
    try {
      if (typeof window !== "undefined") {
        const standalone = window.navigator.standalone;
        const userAgent = window.navigator.userAgent.toLowerCase();
        const safari = userAgent.includes('safari');
        const ios = /iphone|ipod|ipad/.test(userAgent);

        if (ios) {
          if (!standalone && safari) {
            return "ChromeWeb";
          } else if (!standalone && !safari) {
            return "IOSWebView";
          }
        } else {
          if (userAgent.includes("wv")) {
            return "AndroidWebView";
          } else {
            return "SafariWeb";
          }
        }
      } else {
        return "Server";
      }
    } catch (error) {
       console.error(error)
    }
  }

    const browserType=getBrowserType()
    const [hasScript, setHasScript] = useState(false);
    const [appToken, setAppToken] = useState("");
    

  const handleToken = async () => {
    try {
      const payload = {
        "clientId": KEY_CHAIN.FRESHCHAT_CLIENT_ID,
        "mbShortToken": props.shortToken
      }
      const response = await Api.getAppToken(payload);
    
      setAppToken(response?.accessToken);

      if (userPMEntityId && !Object.values(EXCLUDED_PM_ENTITYID_FOR_CHATBOT).includes(userPMEntityId)) {
        setHasScript(true);
      }

    } catch (error) {
      console.error(error);
    }
  }

    useEffect(()=>{
        handleToken();
    },[]);

    useEffect(() => {
      if (hasScript && appToken && browserType) {
            const script = document.createElement('script');
              script.src = '//in.fw-cdn.com/31749060/896280.js';
              script.setAttribute('chat', 'true');
            document.head.appendChild(script);
            script.onload = () => {
              window.fwcrm.on('widget:loaded', () => {
                const appVersion = getCookie("versionCode");
                const platform = getCookie("platform");
                window.fcWidget.conversation.setBotVariables(
                  {
                    browserType: browserType,
                    userAppToken: appToken,
                    versionCode: appVersion,
                    platform: platform,
                  });
              });
            }
          
            window.fcSettings = {
                onInit: async function () {
                  window.fcWidget.on("widget:opened", function(resp) {
                    trackLinkClick({
                      targetUrl: 'mia_widget_opened',
                      elementId: 'script'
                    });
                  });

                  window.fcWidget.on("widget:closed", function(resp) {
                    trackLinkClick({
                      targetUrl: 'mia_widget_closed',
                      elementId: 'script'
                    });
                  });
                }

            }

            window.fcWidgetMessengerConfig = {
                jsFunctions: {
                    redirectToNativeView :(Deeplink) => {
                      let androidDeeplink =Deeplink.androidDeeplink.trim();
                      let iosDeeplink=Deeplink.iosDeeplink.trim();
                      let webDeeplink=Deeplink.webDeeplink.trim();
                      let browserType=Deeplink.browserType.trim();
                        try{
                        switch (browserType) {
                          case "AndroidWebView":
                            window.WebToNativeCommunicationInterface.openDeeplink(androidDeeplink);
                            break;
                          case "IOSWebView":
                            window.webkit.messageHandlers.deepLinkUrl.postMessage(iosDeeplink);
                            break;
                          case "ChromeWeb":
                          case "SafariWeb":
                            if (window.location !== window.parent.location) {
                              window.parent.postMessage(
                                { openLink: webDeeplink },
                                "*"
                              );
                            } else {
                              window.open(webDeeplink, "_blank");
                            }
                            break;
                          default:
                            console.log(browserType + " : no deeplink implementation found");
                            break;
                        }
                      }catch(error){
                        console.log(error);
                        window.open(webDeeplink, "_blank");
                      }
                      }  ,

                    redirectToDialler: (data) => {
                        window.location.href=`tel:${data.phoneNumber}`
                    }
                }
            };
            return () => {
                document.head.removeChild(script);
            };
        }
    }, [hasScript, appToken, browserType]);

    return null;
}
